module.exports = __webpack_public_path__ + "img/t.949e6882.jpg";